module.exports = __webpack_public_path__ + "img/T1C_rc_19.03831cfe.png";